<template>
  <v-card>
    <v-card-text class="text--primary">
      <px-minha-pagina-contato :fornecedor="fornecedor"/>
      <v-divider/>
      <template v-if="fornecedor.score && fornecedor.score.score">
        <px-minha-pagina-score :fornecedor="fornecedor"/>
        <v-divider/>
      </template>
      <template v-if="fornecedor.pessoa.entidade.pontuacaoMedia" id="avaliacao">
        <v-divider/>
        <px-minha-pagina-avaliacao :fornecedor="fornecedor"/>
      </template>
      <v-divider/>
      <px-minha-pagina-localizacao :fornecedor="fornecedor"/>
    </v-card-text>
  </v-card>
</template>

<script>
import MinhaPaginaContato from './MinhaPaginaContato.vue';
import MinhaPaginaAvaliacao from './MinhaPaginaAvaliacao.vue';
import MinhaPaginaScore from './MinhaPaginaScore.vue';
import MinhaPaginaLocalizacao from './MinhaPaginaLocalizacao.vue';

export default {
  props: {
    fornecedor: Object,
  },
  components: {
    pxMinhaPaginaContato: MinhaPaginaContato,
    pxMinhaPaginaAvaliacao: MinhaPaginaAvaliacao,
    pxMinhaPaginaScore: MinhaPaginaScore,
    pxMinhaPaginaLocalizacao: MinhaPaginaLocalizacao,
  },
};
</script>
